import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { decryptText, encryptText } from "../../utils/utils";

interface TabState {
    [key: string]: number; 
}
const STORAGE_KEY = "tabState";

const loadInitialState = (): TabState => {
    try {
        const encrypted = localStorage.getItem(STORAGE_KEY);
        if (!encrypted) return {};
        const decrypted = decryptText(encrypted);
        return JSON.parse(decrypted) || {};
    } catch {
        return {};
    }
  };

const persistState = (state: TabState) => {
    try {
        const stringified = JSON.stringify(state);
        const encrypted = encryptText(stringified);
        localStorage.setItem(STORAGE_KEY, encrypted);
    } catch (e) {
        console.error("Failed to persist encrypted tab state", e);
    }
};
  
const tabSlice = createSlice({
    name: "tab",
    initialState: loadInitialState(),
    reducers: {
        setTabIndex: (state, action: PayloadAction<{ key: string; index: number }>) => {
            const { key, index } = action.payload;
            state[key] = index;
            persistState(state);
        }
    },
});

export const { setTabIndex } = tabSlice.actions;
export default tabSlice.reducer;
